import gql from 'graphql-tag'

export const UPDATE_PASSWORD = gql`
  mutation update_password($input: PasswordInput) {
    update_password(input: $input)
      @rest(type: "PasswordChange", path: "/update-password", bodyKey: "input", method: "POST") {
      response
    }
  }
`
